import React from "react";
import { PageContent } from "../../../page-content/page-content";
import { useQuery } from "@tanstack/react-query";
import { GetActiveReturnRequestHandler } from "../cqrs/get-active-return-requests/get-active-return-requests-handler";
import { BtmReturnsList } from "../btm-returns-list/btm-returns-list";
import { GetActiveReturnRequestQuery } from "../cqrs/get-active-return-requests/get-active-return-request-query";
import { t } from "i18next";
import { WarehouseSelector } from "../../pallet/warehouse-selector/warehouse-selector";
import { context } from "../../../../context/context";
import { useNavigate } from "react-router-dom";
import { BtmReturnRequestListItem } from "../model/btm-return-request-list-item";

import "./style.scss";

export const BTMActiveReturns = ({ warehouseCode }: { warehouseCode: string | undefined }) => {
    return <PageContent title={t("components.blueBrandReturns.page.activeReturns.title")}
                        description={t("components.blueBrandReturns.page.activeReturns.description")}
                        className={"btm-returns-page"}>
        {(context.currentUser.isSuperAdministrator || context.currentUser.isSrmAgent) && <WarehouseSelector section={"btm-returns"} selectedWarehouse={warehouseCode} />}
        {warehouseCode && <BTMActiveReturnsContent warehouseCode={warehouseCode} />}
    </PageContent>;
};

const BTMActiveReturnsContent = ({ warehouseCode }: { warehouseCode: string }) => {
    const { data, isLoading } = useQuery({
        queryKey: [`btm-returns-active-${warehouseCode}`],
        queryFn: async () => await GetActiveReturnRequestHandler(new GetActiveReturnRequestQuery(warehouseCode)),
    });
    const navigate = useNavigate();

    const handleRequestOpen = (requestId: BtmReturnRequestListItem) => {
        navigate(`/btm-returns/details/${requestId.returnRequestId}`);
    };

    return <BtmReturnsList withFilters withStatus withActionColumn data={data} isLoading={isLoading} onRequestOpen={handleRequestOpen} />;
};
